import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { ButtonDirective } from 'shared/directive/button.directive';
import { VersionCheckerService } from 'shared/services/version-checker.service';
import { WINDOW } from 'shared/tools/window-provider';

@Component({
	selector: 'app-version-mismatch-modal',
	templateUrl: './version-mismatch-modal.component.html',
	styleUrl: './version-mismatch-modal.component.scss',
	standalone: true,
	imports: [MatButtonModule, ButtonDirective, MatIconModule, TranslateModule],
})
export class VersionMismatchModalComponent implements OnInit, OnDestroy {
	public showVersionMismatch = false;
	private subscription: Subscription = new Subscription();

	constructor(
		@Inject(WINDOW) private window: Window,
		private versionCheckerService: VersionCheckerService
	) {}

	refresh() {
		window.location.reload();
	}

	ngOnInit(): void {
		this.subscription = this.versionCheckerService.hasVersionMismatch$.subscribe((res) => {
			this.showVersionMismatch = res;
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
